import { useState } from "react";

import { H2RButton } from "../imports";
import useGetMediaLocation from "./hooks/useGetMediaLocation";

export const InputWrapper = ({
	label,
	size = "default",
	helpText,
	children,
}) => {
	return (
		<>
			<p className="text-gray-500 tracking-wide font-semibold text-xs">
				{label}
			</p>

			<div
				className={`
			${size === "default" && "mt-4"}
			${size === "small" && "mt-1"}
			
			`}
			>
				{children}
			</div>
			{helpText && (
				<p className="text-xs font-semibold mt-2 text-gray-500">{helpText}</p>
			)}
			{/* <span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span> */}
		</>
	);
};

export const Input = ({
	value = "",
	size = "default",
	type = "text",
	placeholder = "",
	onChange,
	label = "",
	step = null,
	disabled = false,
	min = null,
	max = null,
	helpText = null,
}) => {
	const [val, setVal] = useState(value);
	return (
		<InputWrapper label={label} size={size} helpText={helpText}>
			<input
				type={type}
				className={`w-full text-gray-300 bg-gray-900 rounded focus:ring focus:outline-none
				${type !== "range" && "border border-solid border-gray-700"}
				${size === "default" && "px-2 py-1 text-base"}
				${size === "small" && "px-1 py-1 text-sm"}
				
				
				`}
				value={val}
				placeholder={placeholder}
				step={step}
				onChange={(e) => {
					onChange(e.target.value);
					setVal(e.target.value);
				}}
				disabled={disabled}
				min={min}
				max={max}
			/>
		</InputWrapper>
	);
};

export const TextArea = ({
	value = "",
	placeholder = "",
	onChange,
	label = "",
	rows = 6,
	resize = true,
	className = ''
}) => {
	const [val, setVal] = useState(value);

	return (
		<InputWrapper label={label}>
			<textarea
				className={[
					"px-2 py-1 text-sm w-full text-gray-300 bg-gray-700 rounded border border-solid border-gray-700 focus:ring focus:ring-main-500 focus:outline-none placeholder-gray-500 transition-all",
					resize ? 'resize' : 'resize-none',
					className,
				].join(' ')}
				value={val}
				rows={rows}
				placeholder={placeholder}
				onChange={(e) => {
					onChange(e.target.value);
					setVal(e.target.value);
				}}
			/>
		</InputWrapper>
	);
};

export const ImagePreview = ({ image, fromUrl = false }) => {
	const [hover, setHovered] = useState(false);
	const mediaLocation = useGetMediaLocation();

	return (
		<InputWrapper label="Image preview">
			<div className="relative flex w-100 h-28 rounded justify-center items-center border border-solid bg-gray-900 border-gray-700">
				<div
					style={{ zIndex: "100" }}
					className="absolute inset-0 w-100 h-full flex items-center justify-center"
				>
					{hover && (
						<p
							style={{
								backgroundColor: "rgba(1,1,1,0.7)",
							}}
							className="bg-gray-900 text-gray-100 w-full h-full  flex items-center justify-center "
						>
							<span className="font-semibold">Replace image</span>
						</p>
					)}
				</div>
				<div
					className="absolute z-1 inset-0 w-100 h-26 flex items-center justify-center bg-contain bg-center"
					style={{
						backgroundImage: fromUrl ? `url(${image})` : `url(${mediaLocation}${image})`,
						backgroundRepeat: "no-repeat",
					}}
				></div>
			</div>
		</InputWrapper>
	);
};

export const VideoPreview = ({ video }) => {
	const mediaLocation = useGetMediaLocation();
	return (
		<InputWrapper label="Video preview">
			<video
				controls={true}
				muted={true}
				disablePictureInPicture={true}
				controlsList="nodownload"
				className="p-1 mx-auto flex w-56 h-32 rounded border border-solid bg-gray-900 border-gray-700 focus:outline-none focus:ring focus:ring-main-500 transition"
				src={`${mediaLocation}${video}`}
			></video>
		</InputWrapper>
	);
};

export const Select = ({ selected, label, options, onSelect }) => {
	return (
		<InputWrapper label={label}>
			<select
				value={selected}
				onChange={(e) => {
					return onSelect(e.target.value);
				}}
				className="px-2 py-1 w-full text-gray-300 bg-gray-900 rounded border border-solid border-gray-700 focus:shadow-lg focus:outline-none"
			>
				<option value="">Choose...</option>
				{options.map((op) => {
					return (
						<option key={op.value} value={op.value}>
							{op.name}
						</option>
					);
				})}
			</select>
		</InputWrapper>
	);
};

export const InputWithButton = ({
	inputLabel,
	inputValue,
	inputDisabled,
	buttonText,
	buttonOnClick,
}) => {
	return (
		<div className="flex items-end">
			<div>
				<Input label={inputLabel} value={inputValue} disabled={inputDisabled} />
			</div>
			<div className="mb-1 ml-2">
				<H2RButton text={buttonText} onClick={buttonOnClick} />
			</div>
		</div>
	);
};
